import { Component, NgZone } from '@angular/core';

import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { AlertController } from 'ionic-angular';

@Component({
  selector: 'einsatzplan-create',
  templateUrl: 'einsatzplan-create.html'
})
export class EinsatzplanCreatePage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  oSelectedEinsatzplan;

  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , private alertCtrl: AlertController
            ) {
    //let selectedpp = navParams.get('pp');
    
    this.init();
    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oSelectedEinsatzplan = navParams.data;
    //console.log(this.oSelectedEinsatzplan);

   }

   init(){
  

   }

   stornoEinsatzplan(){

      let alert = this.alertCtrl.create({
        title: 'Einsatzplan stornieren',
        message: 'Wollen Sie die Einsatzplan vom '+this.oSelectedEinsatzplan.datum+' wirklich stornieren ?',
        buttons: [
          {
            text: 'Nein',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Ja',
            handler: () => {
              console.log('TODO Einsatzplan stornieren');
            }
          }
        ]
      });
      alert.present();

   }

  
}



// WEBPACK FOOTER //
// ./src/pages/einsatzplan/einsatzplan-create.ts